import _ from "lodash";
import { LocPrefixService } from "../../../LocationPrefixEditor/LocationPrefixService";
export const onMaintenanceReceive = (prevProps, props, setState, lineAsset, getAssetLinesWithSelf) => {
  if (props.maintenanceActionType == "MAINTENANCE_READ_SUCCESS" && prevProps.maintenanceActionType != props.maintenanceActionType) {
    let m = _.cloneDeep(props.maintenance);
    let allMaintenanceIds = [];
    if (m.executions && m.executions.length > 0) {
      m.executions.forEach((excid) => {
        allMaintenanceIds.push(excid);
      });
      if (allMaintenanceIds.length !== 0) {
        let params = allMaintenanceIds.join(",");
        const getByIds = `getByIds/${params}`;
        props.getJourneyPlans(getByIds);
      }
    }

    let milePostAsset = m.location && m.location.length ? m.location.findIndex((l) => l.type === "Milepost") : null;
    let returnedObj = handleMaintenanceLocationClick(milePostAsset, m, lineAsset);
    getAssetLinesWithSelf();
    setState({ maintenance: m, maintenanceDefectCodesObj: { unit: m.asset, defectCodes: m.defectCodes }, ...returnedObj });
  }
};

export const onExecutionInspectionReceive = (prevProps, props, setState,getAppMockupsTypes) => {
  if (props.journeyPlanActionType == "JOURNEYPLANS_READ_SUCCESS" && props.journeyPlanActionType !== prevProps.journeyPlanActionType) {
    if (props.journeyPlans && props.journeyPlans.length !== 0) {
      const maintenanceDetails = props.journeyPlans.map((jplan) => jplan);
      const selectedRowData = maintenanceDetails[0];

      setState({ maintenanceDetails, selectedRowData });
    }

    getAppMockupsTypes("materialTypes");
  }
};

export const onMaterialTypesReceive=(prevProps,props,setSummaryData)=>{

  if (prevProps.diagnosticsActionType !== props.diagnosticsActionType) {
    if (props.diagnosticsActionType === "GET_MATERIALTYPES_SUCCESS") {
      setSummaryData();
    }

    else if (props.diagnosticsActionType === "GET_MATERIALTYPES_FAILURE"){
      setSummaryData();
    }
  }

  
}

export const onLineSelfLoad = (prevProps, props, setState, state) => {
  if (
    !state.gisDisplay &&
    props.lineAssets &&
    state.maintenance &&
    state.maintenance.lineId &&
    props.assetHelperActionType == "GET_LINE_ASSETS_WITH_SELF_SUCCESS" &&
    props.assetHelperActionType !== prevProps.assetHelperActionType
  ) {
    let line = props.lineAssets.find((l) => {
      return l._id == state.maintenance.lineId;
    });
    setState({ lineAsset: line, gisDisplay: true });
  }
};

export const handleMaintenanceLocationClick = (index, maintenance, lineAssets) => {
  let selectedAsset = { start: 5, end: 5, icon: "circle-stroked-15" };
  let location = maintenance.location ? maintenance.location[index] : null;
  if (!location) return false;
  let line = null,
    enableDisplay = true;
  if (location.type == "GPS") {
    selectedAsset = { type: "GPS", start: location.start, end: location.end };
  } else if (location.type == "Milepost") {
    selectedAsset.start = location.start;
    selectedAsset.end = location.end;
    selectedAsset.text = location.unitId;
    selectedAsset.visible = true;
    selectedAsset._id = location._id;
    selectedAsset.sPrefix = LocPrefixService.getPrefixMp(location.start, maintenance.lineId);
    selectedAsset.ePrefix = LocPrefixService.getPrefixMp(location.end, maintenance.lineId);

    if (lineAssets && maintenance && maintenance.lineId) {
      line = lineAssets.find((l) => {
        return l._id == maintenance.lineId;
      });
    } else enableDisplay = false;
  }

  maintenance.location[index].sPrefix = LocPrefixService.getPrefixMp(maintenance.location[index].start, maintenance.lineId);
  maintenance.location[index].ePrefix = LocPrefixService.getPrefixMp(maintenance.location[index].end, maintenance.lineId);
  return {
    gisDisplay: enableDisplay,
    selectedAsset: selectedAsset,
    lineAsset: line,
    maintenance: maintenance,
  };
};



// WEBPACK FOOTER //
// ./src/components/Maintenance/MaintenanceDetailPage/HelperMethods/MaintenanceDetailHelper.js